export function finish(id, bet, key) {
    return {
        type: 'BETS_PLACED',
        id: id,
        bet: bet,
        key
    };
}

export function subscribe() {
    return {
        type: 'BETS_SUBSCRIBE'
    };
}

export function unsubscribe( id, key ) {
    return {
        type: 'BETS_UNSUBSCRIBE',
        id,
        key
    };
}

export function subscribeRejected() {
    return {
        type: 'BETS_SUBSCRIBE_REJECTED'
    };
}

export function subscribeSettled() {
    return {
        type: 'BETS_SUBSCRIBE_SETTLED'
    };
}

export function openWindow(layout) {
    window.open(`/bet-ticker-single?layout=${layout}`);
    return { type: 'BET_TICKER_NEW_WINDOW_OPENED' };
}

// TODO: Remove this modifier when Kafka bet model will be extended with ip field
export function addBetTickerBet(id, bet, key) {
    return {
        type: 'BETS_MODIFY_WITH_IP',
        id: id,
        bet: bet,
        key
    };
}
